import React from 'react'
import ReactivateAccount from '../components/reactivateAccount/ReactivateAccount'

const ReactivateAccountPage = () => {

  return (
    <ReactivateAccount />
  )
}

export default ReactivateAccountPage
